export default {
  enter: {
    transition: { staggerChildren: 0.1 },
  },
}
